// extracted by mini-css-extract-plugin
export default {"wrapper":"Toggle_wrapper__rtryd","optionButton":"Toggle_optionButton__9q59m","selected":"Toggle_selected__oVMrS"};